/* Inhaltsstoffe – Register-Filter (Gruppe / Thema): Progressive Enhancement, ohne Abhängigkeiten.
   Ohne JS bleibt der Filter versteckt und alle Einträge sind sichtbar. Re-Init nach dem Neuladen der Section im Theme-Editor. */
(() => {
  const GROUP = { vit: 'Vitamine', min: 'Mineralstoffe & Spurenelemente', wei: 'weitere Inhaltsstoffe' };

  function init(scope) {
    const root = (scope || document).querySelector('[data-reg]');
    if (!root || root.dataset.regReady) return;
    const bar = root.querySelector('[data-reg-filter]'), status = root.querySelector('[data-reg-status]'), body = root.querySelector('[data-reg-body]');
    if (!bar || !status || !body) return;
    root.dataset.regReady = '1';
    const items = [...root.querySelectorAll('.reg-item')], groups = [...root.querySelectorAll('.reg-group')], chips = [...bar.querySelectorAll('[data-filter]')];
    const total = items.length;
    chips.filter(c => c.dataset.filter.startsWith('t:')).forEach(c => {
      const n = items.filter(i => i.dataset.topics.split(' ').includes(c.dataset.filter.slice(2))).length;
      c.insertAdjacentHTML('beforeend', ' <span>' + n + '</span>');
    });
    bar.hidden = false; root.classList.add('has-filter');

    function apply(f) {
      const [kind, val] = f.split(':'); let n = 0;
      items.forEach(it => {
        const show = kind === 'all' || (kind === 'g' ? it.dataset.group === val : it.dataset.topics.split(' ').includes(val));
        it.hidden = !show; if (show) n++;
        it.querySelectorAll('[data-topic]').forEach(li => li.classList.toggle('is-match', kind === 't' && li.dataset.topic === val));
      });
      groups.forEach(g => { g.hidden = !g.querySelector('.reg-item:not([hidden])'); });
      root.classList.toggle('is-topic', kind === 't');
      chips.forEach(c => c.setAttribute('aria-pressed', String(c.dataset.filter === f)));
      const chip = chips.find(c => c.dataset.filter === f);
      status.textContent = kind === 'all' ? 'Alle ' + total + ' Wirkstoffe'
        : kind === 'g' ? n + ' ' + GROUP[val] + ' von ' + total + ' Wirkstoffen'
        : n + ' Nährstoffe mit zugelassener Aussage zum Thema „' + chip.firstChild.textContent.trim() + '“';
      const off = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0) + 24;
      const top = body.getBoundingClientRect().top;
      if (top < off) scrollTo({ top: scrollY + top - off, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    bar.addEventListener('click', e => { const c = e.target.closest('[data-filter]'); if (c) apply(c.dataset.filter); });
  }

  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
